import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class FavoriteState {
    constructor() {
        /**
         * Цвелевой элемент
         * @type {Element}
         */
        this.wrapper = null;

        /**
         * Обёртка вывода кол-ва избранного
         * @type {Element}
         */
        this.countWrapper = null;

        /**
         * Обёртка для вывода добавили/удалили из избранного
         * @type {Element}
         */
        this.labelWrapper = null;

        /**
         * Обёртка для вывода инфы по объекту который добавили/удалили
         * @type {Element}
         */
        this.titleWrapper = null;

        /**
         * Таймер для отсчёта показа сообщения о добавлении
         * @type {null}
         */
        this.timer = null;
    }

    /**
     * Инициализация
     * @param {object} options - параметры
     */
    init(options) {
        this.wrapper = options.wrapper;

        this._getElements();
        this._showCount();
        this._subscribers();
    }

    /**
     * Получение элементов
     * @private
     */
    _getElements() {
        this.countWrapper = this.wrapper.querySelector('.j-favorite-state-count');
        this.labelWrapper = this.wrapper.querySelector('.j-favorite-state-label');
        this.titleWrapper = this.wrapper.querySelector('.j-favorite-state-title');
    }

    /**
     * Показывает кол-во элементов в избранном
     */
    _showCount() {
        const favoriteCount = this._getFavorite().length;
        const method = favoriteCount < 1 ? 'remove' : 'add';

        this.countWrapper.innerText = favoriteCount > 9 ? '9+' : favoriteCount;
        this.wrapper.classList[method]('is-show-count');
    }

    /**
     * Скрывает сообщение, что добавили в избранное
     * @private
     */
    _hideMessage() {
        this.wrapper.classList.remove('is-active');

        clearTimeout(this.timer);
    }

    /**
     * Показывает сообщение, что добавили в избранное
     * @param {string} message - сообщение
     * @param {string} title - заголовок
     */
    _showMessage(message, title) {
        this.labelWrapper.innerText = message;
        this.titleWrapper.innerText = title;

        this.wrapper.classList.add('is-active');

        this.timer = setTimeout(this._hideMessage.bind(this), 2000);
    }

    /**
     * Получаем список избранных квартир из куки
     * @returns {array} список избранного из куки
     */
    _getFavorite() {
        const cookieFavorite = Utils.getCookie('favorite');

        if (!cookieFavorite) {
            return [];
        }

        return JSON.parse(cookieFavorite);
    }

    /**
     * Подписка
     * @private
     */
    _subscribers() {
        observer.subscribe('favorite:add', ({title}) => {
            this._hideMessage();
            this._showMessage('Добавлено в избранное', title);
        });

        observer.subscribe('favorite:remove', ({title}) => {
            this._hideMessage();
            this._showMessage('Удаленно из избранного', title);
        });

        observer.subscribe('favorite:update', () => {
            this._showCount();
        });
    }
}

export default FavoriteState;
